import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { GridConstants } from '../../constants/Grid';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, getDominantColor } from '../../lib/ArtUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { isRadioOnly, isUnavailable } from '../../lib/RightsUtils';

import CatalogGridItem from './CatalogGridItem';
import { messages } from './constants';

/**
 * ArtistTopSongsGridItem is for rendering T3 grid items for artist top songs.
 *
 * See CatalogGridItem and lib/GridItem for additional available props.
 */
class ArtistTopSongsGridItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
    isPlayingCurrently: PropTypes.bool,
    isPaused: PropTypes.bool,
    mainText: PropTypes.string,
    mainTextUrl: PropTypes.string,
    itemOnclickUrl: PropTypes.string,
    intl: PropTypes.object,
  };

  render() {
    return (
      <CatalogGridItem
        secondText={this.props.intl.formatMessage(messages.topSongs)}
        {...this.props}
      />
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const { id } = ownProps;
  const props = {};
  const artistId = getInDomain('catalog.utils.mapPseudoSourceToParent')(state, id);
  const details = getAnnotationsById(state, artistId);
  props.blankItem = !details;
  if (details && id && artistId && id !== artistId) {
    const backstageUrl = details.get('shareableUrlPath');
    props.mainText = details.get('name');
    props.mainTextUrl = backstageUrl;
    props.itemOnclickUrl = backstageUrl;
    props.isPlayingCurrently = getInDomain('playback.utils.isSourcePlayingCurrently', false)(
      state,
      id,
    );
    props.isPaused =
      !getInDomain('playback.utils.isAudioPlaying')(state) && props.isPlayingCurrently;
    props.imgUrl = getArt(details, GridConstants.GRID_ITEM_IMAGE_SIZE, state);
    props.isRadioOnly = isRadioOnly(details);
    props.isUnavailable = isUnavailable(details);
    props.explicitness = details.get('explicitness');
    props.dominantColor = getDominantColor(details);
  }
  return props;
}

export default injectIntl(connect(mapStateToProps)(ArtistTopSongsGridItem));
